module.exports = __webpack_public_path__ + "static/media/hero.3ed4e23d.jpg";